import { IBudgetSummary } from '../../../createAndEdit/types';

interface IDetailSummaryMobileProps {
  summary: IBudgetSummary;
  counterProposalAcceptedAt?: string | null;
}

const DetailSummaryMobile = (props: IDetailSummaryMobileProps) => {
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  const total = props.summary.totalToPay - (props.summary.subscriptionBalanceApplied || 0);

  return (
    <div className="border border-gray-300 dark:border-neutral-700 rounded-md p-3">
      <div className="flex flex-col gap-3">
        <div className="flex flex-row items-center justify-between gap-2">
          <span className="text-gray-600 dark:text-neutral-400">Subtotal:</span>
          <span className="font-bold">{formatCurrency(props.summary.subtotal)}</span>
        </div>
        <div className="flex flex-row items-center justify-between gap-2">
          <span className="text-green-600 dark:text-green-400">Descontos:</span>
          <span className="font-bold text-green-600 dark:text-green-400">{formatCurrency(props.summary.discounts)}</span>
        </div>
        {props.summary.subscriptionBalanceApplied ? <div className="flex flex-row items-center justify-between gap-2">
          <span className="text-green-600 dark:text-green-400">Saldo do plano utilizado:</span>
          <span className="font-bold text-green-600 dark:text-green-400">{formatCurrency(props.summary.subscriptionBalanceApplied)}</span>
        </div> : null}
        <div className={`flex flex-row items-center justify-between gap-2 ${props.counterProposalAcceptedAt ? 'line-through' : ''}`}>
          <span className="font-bold text-size-14">Valor a ser pago:</span>
          <span className="font-bold text-size-14">{formatCurrency(total)}</span>
        </div>
        {props.counterProposalAcceptedAt && (
          <div className="flex flex-row items-center justify-between gap-2">
            <span className="font-bold text-size-14">Valor a ser pago:</span>
            <span className="font-bold text-size-14">{formatCurrency(props.summary.counterProposalValue || 0)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailSummaryMobile;
